module.exports = __webpack_public_path__ + "img/Butterfly_00017.a157e5b0.png";